// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    title: {
        marginTop: '5em'
    },
    ulItems: {
        paddingLeft: '1.2em'
    },
    liLink: {
        borderBottom: '1px dotted #eee',
        borderBottomColor: theme.palette.primary.light,
        paddingBottom: '0.1em',
        '&:hover': {
            textDecoration: 'none',
            borderBottomColor: theme.palette.primary.main,
        }
    },
    downloadURLIcon: {
        verticalAlign: 'middle',
        marginTop: '-0.1em'
    },
    preParent: {
        backgroundColor: '#282c34',
        border: '1px solid #ddd',
        borderRadius: '2px',
        '& pre': {
            whiteSpace: 'pre-wrap',
        },
        '& code': {
            fontSize: '1rem',
            [theme.breakpoints.down('md')]: {
                fontSize: '.9rem',
            },
            color: '#fff'
        }
    },
    jsonKey: {
        paddingLeft: '3rem',
        [theme.breakpoints.down('md')]: {
            fontSize: '.88rem',
            paddingLeft: '.9rem',
        },
        fontFamily: 'SF Mono, monospace',
        color: '#e06c75',
    },
    jsonValue: {
        fontFamily: 'SF Mono, monospace',
        [theme.breakpoints.down('md')]: {
            fontSize: '.88rem',
        },
        color: '#98c379'
    },
    jsonChar: {
        color: '#abb2bf',
        fontFamily: 'SF Mono, monospace',
    },
    codeText: {
        fontFamily: 'SF Mono, monospace',
        color: '#e06c75',
    }
});

const Download = (props) => {
    const trainDownloadURL = "https://dl.fbaipublicfiles.com/LVIS/lvis_v1_train.json.zip";
    const valDownloadURL = "https://dl.fbaipublicfiles.com/LVIS/lvis_v1_val.json.zip";
    const testDevDownloadURL = "https://dl.fbaipublicfiles.com/LVIS/lvis_v1_image_info_test_dev.json.zip";
    const testChallengeDownloadURL = "https://dl.fbaipublicfiles.com/LVIS/lvis_v1_image_info_test_challenge.json.zip";
    const trainImagesUrl = "http://images.cocodataset.org/zips/train2017.zip";
    const valImagesUrl = "http://images.cocodataset.org/zips/val2017.zip";
    const testImagesUrl = "http://images.cocodataset.org/zips/test2017.zip";
    const cocoURL = "http://cocodataset.org/#home";
    const lvisAPI = "https://github.com/lvis-dataset/lvis-api";
    const licenseURL = "https://creativecommons.org/licenses/by/4.0/";
    const cocoTerms = "http://cocodataset.org/#termsofuse";

    function jsonLine (key, value) {
        return (
            <React.Fragment>
                <Grid item xs={6}>
                    <span className={props.classes.jsonKey}> {key} </span>
                </Grid>
                <Grid item align="left" xs={6}>
                    <span className={props.classes.jsonValue}> <font color="#abb2bf">:</font> {value}</span>
                </Grid>
            </React.Fragment>
        )
    };

    return (
        <Grid
            container
            justify="center"
            alignItems="center"
        >
            <Grid
                item
                xs={10}
                md={8}
                lg={7}
            >
                <Grid
                    container
                    justify="flex-start"
                    alignItems="center"
                    spacing={16}
                >
                    <Grid item className={props.classes.title} xs={12}>
                        <Typography variant="h3" align="left">
                            LVIS Dataset
                    </Typography>
                    </Grid>
                    <br />
                   <Grid item className={props.classes.versionNumber} xs={12}>
                        <Typography variant="h4" align="left">
                            v1.0
                     </Typography>
                     </Grid>

                    <Grid className={props.classes.setItems} item xs={12} sm={6} xl={3}>
                        <Typography variant="h5" align="left">
                            Training set <Link
                                href={trainDownloadURL}>
                                    <CloudDownload className={props.classes.downloadURLIcon} />
                                </Link>
                        </Typography>
                        <ul className={props.classes.ulItems}>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={trainDownloadURL}>
                                    1,270,141 instances
                                </Link> (1 GB)
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={trainImagesUrl}>
                                    100,170 images
                                </Link> (18 GB)
                                </Typography>
                            </li>
                        </ul>
                    </Grid>
                    <Grid className={props.classes.setItems} item xs={12} sm={6} xl={3}>
                        <Typography variant="h5" align="left">
                            Validation set <Link
                                href={valDownloadURL} download>
                                    <CloudDownload className={props.classes.downloadURLIcon} />
                                </Link>
                        </Typography>
                        <ul className={props.classes.ulItems}>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={valDownloadURL} download>
                                    244,707 instances
                                </Link> (192 MB)
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={valImagesUrl}>
                                    19,809 images
                                </Link> (1 GB)
                                </Typography>
                            </li>
                        </ul>
                    </Grid>
                    <Grid className={props.classes.setItems} item xs={12} sm={6} xl={3}>
                        <Typography variant="h5" align="left">
                            Test Dev <Link
                                href={testDevDownloadURL} download>
                                    <CloudDownload className={props.classes.downloadURLIcon} />
                                </Link>
                        </Typography>
                        <ul className={props.classes.ulItems}>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={testDevDownloadURL}>
                                    info
                                </Link> (4 MB)
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={testImagesUrl}>
                                    19,822 images
                                </Link> (6 GB)
                                </Typography>
                            </li>
                        </ul>
                    </Grid>
                    <Grid className={props.classes.setItems} item xs={12} sm={6} xl={3}>
                        <Typography variant="h5" align="left">
                            Test Challenge <Link
                                href={testChallengeDownloadURL} download>
                                    <CloudDownload className={props.classes.downloadURLIcon} />
                                </Link>
                        </Typography>
                        <ul className={props.classes.ulItems}>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={testChallengeDownloadURL}>
                                    info
                                </Link> (4 MB)
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="subtitle1" align="left">
                                    <Link className={props.classes.liLink} href={testImagesUrl}>
                                    19,822 images
                                </Link> (6 GB)
                                </Typography>
                            </li>
                        </ul>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" align="left">
                        Please see our recommended <Link href="https://www.lvisdataset.org/bestpractices">best practices</Link> for using this data.


                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" align="left">
                            <b>Note</b>: LVIS uses the COCO 2017 train, validation, and
                            test image sets. If you have already downloaded the COCO
                            images, you only need to download the LVIS annotations. LVIS val 
                            set contains images from COCO 2017 train in addition to the 
                            COCO 2017 val split.
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <br />
                        <Divider />
                        <br />
                    </Grid>
                    {/* Section: Data Format */}
                    <Grid item xs={12} md={12}>
                        <Typography variant="h4" align="left">Data Format</Typography>
                        <br />
                        <Typography variant="subtitle1" align="left">
                            LVIS has annotations for instance segmentations in a
                            format similar to&nbsp;
                            <Link className={props.classes.liLink} href={cocoURL}>
                            COCO
                        </Link>. The annotations are stored using JSON. The
                            <Link className={props.classes.liLink} href={lvisAPI}> LVIS API</Link>
                            &nbsp;can be used to access and manipulate annotations.
                            The JSON file has the following format:
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={16}
                    >
                        <Grid item xs={12} md={8}>
                            <Typography component="span" align="left" className={props.classes.preParent}>
                                <Typography component="pre">
                                    <Typography component="span" variant="body1">
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("info", "info")}
                                            {jsonLine("images", "[images],")}
                                            {jsonLine("annotations", "[annotations],")}
                                            {jsonLine("licenses", "[licenses],")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`info{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("year", "int")}
                                            {jsonLine("version", "str,")}
                                            {jsonLine("description", "str,")}
                                            {jsonLine("contributor", "str,")}
                                            {jsonLine("url", "str,")}
                                            {jsonLine("date_created", "datetime,")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`license{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("id", "int")}
                                            {jsonLine("name", "str,")}
                                            {jsonLine("url", "str,")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography variant="subtitle1" align="left">
                            We describe the data structures a bit more in detail below.
                        </Typography>
                    </Grid>

                    {/* Section: Images */}
                    <Grid item xs={12} md={12}>
                        <Typography variant="h5" align="left">Images</Typography>
                        <br />
                        <Typography variant="subtitle1" align="left">
                            Each image now comes with two additional fields.
                            <ul className={props.classes.ulItems}>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`not_exhaustive_category_ids`} </code>:
                                        List of category ids which don't have all of their instances marked exhaustively.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`neg_category_ids`} </code>:
                                        List of category ids which were verified as not present in the image.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`coco_url`} </code>:
                                        Image URL. The last two path elements identify the split in the COCO dataset and the 
                                        file name (e.g., http://images.cocodataset.org/train2017/000000391895.jpg). 
                                        This information can be used to load the correct image from your downloaded copy of the COCO dataset.
                                    </Typography>
                                </li>
                            </ul>

                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={16}
                    >
                        <Grid item xs={12} md={8}>
                            <Typography component="span" align="left" className={props.classes.preParent}>
                                <Typography component="pre">
                                    <Typography component="span" variant="body1">
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`image{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("id", "int")}
                                            {jsonLine("width", "int,")}
                                            {jsonLine("height", "int,")}
                                            {jsonLine("license", "int,")}
                                            {jsonLine("flickr_url", "str,")}
                                            {jsonLine("coco_url", "str,")}
                                            {jsonLine("date_captured", "datetime,")}
                                            {jsonLine("not_exhaustive_category_ids", "[int],")}
                                            {jsonLine("neg_category_ids", "[int],")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Section: Categories */}
                    <Grid item xs={12} md={12}>
                        <Typography variant="h5" align="left">Categories</Typography>
                        <br />
                        <Typography variant="subtitle1" align="left">
                            LVIS categories are loosely based on WordNet synsets.
                            <ul className={props.classes.ulItems}>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`synset`} </code>:
                                        Provides a unique string identifier for each category. Loosely based on WordNet synets.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`synonyms`} </code>:
                                        List of object names that belong to the same synset.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`def`} </code>:
                                        The meaning of the synset. Most of the meanings are derived from WordNet.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`image_count`} </code>:
                                        Number of images in which the category is annotated.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`instance_count`} </code>:
                                        Number of annotated instances of the category.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        <code className={props.classes.codeText}> {`frequency`} </code>:
                                        We divide the categories into three buckets based on
                                        <code className={props.classes.codeText}> {`image_count`} </code> in the train set.
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={16}
                    >
                        <Grid item xs={12} md={8}>
                            <Typography component="span" align="left" className={props.classes.preParent}>
                                <Typography component="pre">
                                    <Typography component="span" variant="body1">
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`categories{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("id", "int")}
                                            {jsonLine("synset", "str,")}
                                            {jsonLine("synonyms", "[str],")}
                                            {jsonLine("def", "str,")}
                                            {jsonLine("instance_count", "int,")}
                                            {jsonLine("image_count", "int,")}
                                            {jsonLine("frequency", "str,")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Section: Annotations */}
                    <Grid item xs={12} md={12}>
                        <Typography variant="h5" align="left">Annotations</Typography>
                        <br />
                        <Typography variant="subtitle1" align="left">
                            The segmentation format in LVIS is always a list of polygons.
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={16}
                    >
                        <Grid item xs={12} md={8}>
                            <Typography component="span" align="left" className={props.classes.preParent}>
                                <Typography component="pre">
                                    <Typography component="span" variant="body1">
                                        <br/>
                                        <div> <code className={props.classes.jsonChar}> {`annotation{`} </code> </div>
                                        <Grid container>
                                            {jsonLine("id", "int")}
                                            {jsonLine("image_id", "int,")}
                                            {jsonLine("category_id", "int,")}
                                            {jsonLine("segmentation", "[polygon],")}
                                            {jsonLine("area", "float,")}
                                            {jsonLine("bbox", "[x,y,w,h],")}
                                        </Grid>
                                        <div> <code className={props.classes.jsonChar}> {`}`} </code> </div>
                                        <br/>
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <br />
                        <Divider />
                        <br />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography variant="h4" align="left"><a name="changelog"></a>Changelog</Typography>
                        <br/>
                        <Typography variant="subtitle1" align="left">
                            <b>V1.0</b>:
                            <ul className={props.classes.ulItems}>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        The total dataset size has been expanded to ~160k images and ~2M instance
                                        annotations.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        The total number of categories has decreased slightly (from 1230 to 1203) due
                                        to more stringent quality control.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        The validation set has been expanded from 5k images to 20k images.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        The <code className={props.classes.codeText}> {`file_name`} </code> field was
                                        removed from the  <code className={props.classes.codeText}> {`image`} </code> structure.
                                        Explanation: the V1.0 splits no longer match one-to-one with the COCO splits (the LVIS V1.0 validation 
                                        set contains images from the COCO train 2017 split). As a result, the old
                                        <code className={props.classes.codeText}> {`file_name`} </code> field does not uniquely
                                        identify an image in the COCO dataset. We recommend using the <code className={props.classes.codeText}> {`coco_url`} </code>
                                        field to identify the COCO split and image file name.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        There are now two test sets: Test Dev and Test Challenge. The former will be available for year-round
                                        evaluation (subject to a usage quota) while the latter will be available only once a year for the 
                                        purpose of the LVIS Challenge.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="subtitle1" align="left">
                                        We have developed a set of <Link href="https://www.lvisdataset.org/bestpractices">best practices</Link> for using LVIS.
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <br />
                        <Divider />
                        <br />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography variant="h4" align="left"><a name="license"></a>License</Typography>
                        <br/>
                        <Typography variant="subtitle1" align="left">
                            The LVIS annotations along with this website are licensed under a
                            <Link href={licenseURL}> Creative Commons Attribution 4.0 License</Link>. All LVIS dataset images
                            come from the COCO dataset; please see <Link href={cocoTerms}> link </Link>
                            for their terms of use.
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>

    )
}

export default withStyles(styles)(Download);
